import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CustomSelect from './CustomSelect';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { es } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '15px'
    }
  },
  containerDatepiker: {
    width: '160px',
    marginLeft: '0px',
    marginRight: '10px',
    marginTop: '0px',
    marginBottom: '0px',
    backgroundColor: 'white',
    [theme.breakpoints.down('md')]: {
      marginLeft: '0px',
      marginRight: '0px'
    }
  },
  input: {
    paddingTop: '8px',
    paddingBottom: '8px'
  }
}));

export default function CustomDatepicker ({ onChange, htmlFor }) {
  const { t } = useTranslation();
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [showDatePickers, setShowDatePickers] = React.useState(false);
  const classes = useStyles();
  const today = new Date();
  const lastTwelveMonths = new Date(today.getFullYear(), today.getMonth() - 11, today.getDate());
  const lastSixMonths = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
  const lastThreeMonths = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
  const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

  const itemsDates = [
    { value: 1, label: 'lastTwelveMonths' },
    { value: 2, label: 'lastSixMonths' },
    { value: 3, label: 'lastThreeMonths' },
    { value: 4, label: 'lastMonth' },
    { value: 5, label: 'custonDate' }
  ];

  React.useEffect(() => {
    onChange({ startDate: transformDate(lastMonth), endDate: transformDate(today) });
  }, []);

  const transformDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleStartDate = (date) => {
    setStartDate(date);
    onChange({ startDate: transformDate(date), endDate: transformDate(endDate) });
  };

  const handleEndDate = (date) => {
    setEndDate(date);
    onChange({ startDate: transformDate(startDate), endDate: transformDate(date) });
  };

  const handleCustomDate = (date) => {
    if (date === 1) {
      onChange({ startDate: transformDate(lastTwelveMonths), endDate: transformDate(today) });
    }
    if (date === 2) {
      onChange({ startDate: transformDate(lastSixMonths), endDate: transformDate(today) });
    }
    if (date === 3) {
      onChange({ startDate: transformDate(lastThreeMonths), endDate: transformDate(today) });
    }
    if (date === 4) {
      onChange({ startDate: transformDate(lastMonth), endDate: transformDate(today) });
    }
    if (date === 5) {
      setShowDatePickers(true);
    } else {
      setShowDatePickers(false);
    }
  };

  return (
    <div className={classes.container}>
      <CustomSelect menuItems={itemsDates} onChange={handleCustomDate} label={'Ultimo mes'} labelId={htmlFor} />
      {showDatePickers && (
        <div>
          <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={classes.containerDatepiker}
              inputProps={{ className: classes.input }}
              disableToolbar
              variant='inline'
              format='MM/dd/yy'
              margin='normal'
              id='date-picker-inline'
              label={t('exportData:from')}
              value={startDate}
              inputVariant='outlined'
              onChange={handleStartDate}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
            <KeyboardDatePicker
              className={classes.containerDatepiker}
              inputProps={{ className: classes.input }}
              disableToolbar
              variant='inline'
              format='MM/dd/yy'
              margin='normal'
              id='date-picker-inline'
              label={t('exportData:to')}
              value={endDate}
              inputVariant='outlined'
              onChange={handleEndDate}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </MuiPickersUtilsProvider>
        </div>
      )}
    </div>
  );
}

CustomDatepicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  htmlFor: PropTypes.string
};
